import { useEffect, useState } from 'react';

export interface MePayload {
  userId: string;
  email: string | undefined;
  role: string;
}

let cached: MePayload | null = null;
let inFlight: Promise<MePayload | null> | null = null;

export function _resetMeCache(): void {
  cached = null;
  inFlight = null;
}

export async function fetchMe(fetcher: typeof fetch = fetch): Promise<MePayload | null> {
  if (cached) return cached;
  if (inFlight) return inFlight;
  inFlight = (async () => {
    try {
      const res = await fetcher('/api/me');
      if (!res.ok) return null;
      const parsed = (await res.json()) as MePayload;
      cached = parsed;
      return parsed;
    } catch {
      return null;
    } finally {
      inFlight = null;
    }
  })();
  return inFlight;
}

export interface UseMeOpts {
  enabled: boolean;
  fetcher?: typeof fetch;
}

export function useMe(opts: UseMeOpts): MePayload | null {
  const [value, setValue] = useState<MePayload | null>(cached);
  useEffect(() => {
    if (!opts.enabled) return;
    let cancelled = false;
    fetchMe(opts.fetcher).then((p) => {
      if (!cancelled) setValue(p);
    });
    return () => {
      cancelled = true;
    };
  }, [opts.enabled, opts.fetcher]);
  return value;
}
